(function(){
  var h=document.querySelector('.hdr');
  if(h){var f=function(){h.classList.toggle('scrolled',window.scrollY>8)};f();window.addEventListener('scroll',f,{passive:true});}
  var b=document.querySelector('.burger'),m=document.querySelector('.mnav');
  if(b&&m){b.addEventListener('click',function(){var o=m.classList.toggle('open');b.setAttribute('aria-expanded',o)});
    m.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){m.classList.remove('open')})});}
  var els=document.querySelectorAll('.rv');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e)});
  } else els.forEach(function(e){e.classList.add('in')});
  // engraving counter
  var eng=document.querySelector('[data-engrave]'),cnt=document.querySelector('[data-engrave-count]');
  if(eng&&cnt){var u=function(){cnt.textContent=eng.value.length+' / '+eng.maxLength};eng.addEventListener('input',u);u();}
})();
/* monthly drops: 26 numbers at drop_hour (Beirut) on the 26th of every month */
(function(){
  var C=window.TEN_DROP; if(!C) return;
  var TZ='Asia/Beirut', MON=['January','February','March','April','May','June','July','August','September','October','November','December'];
  function offsetMin(ms){ // Beirut offset from UTC in minutes at instant ms
    var p={}; new Intl.DateTimeFormat('en-US',{timeZone:TZ,hourCycle:'h23',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit'}).formatToParts(new Date(ms)).forEach(function(x){p[x.type]=+x.value;});
    return (Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute)-ms)/60000;
  }
  function beirut(y,m,d,h){ var g=Date.UTC(y,m,d,h); return g-offsetMin(g)*60000; }
  function nowParts(){ var p={}; new Intl.DateTimeFormat('en-US',{timeZone:TZ,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date()).forEach(function(x){p[x.type]=+x.value;}); return p; }
  var f=(C.first||'2026-10-26').split('-').map(Number), y0=f[0], m0=f[1]-1, H=C.hour||20, N=Math.ceil(C.total/C.size);
  function dropFor(y,m){ var n=(y-y0)*12+(m-m0)+1; return n; }
  function nums(n){ var a=(n-1)*C.size+1, b=Math.min(n*C.size,C.total); var z=function(x){return ('00'+x).slice(-3);}; return [a,b,z(a)+'–'+z(b),b-a+1]; }
  function state(){
    var now=Date.now(), p=nowParts(), y=p.year, m=p.month-1;
    var n=dropFor(y,m);
    if(n<1){ y=y0; m=m0; n=1; }
    var at=beirut(y,m,26,H);
    var live=false;
    if(now>=at){
      if(C.soldOut && +C.soldOut===n){ m++; if(m>11){m=0;y++;} n++; at=beirut(y,m,26,H); }
      else live=true;
    }
    if(n>N) return {done:true};
    return {n:n,at:at,live:live,y:y,m:m,nums:nums(n)};
  }
  function pad(x){return (x<10?'0':'')+x;}
  function render(){
    var S=state(); window.TEN_DROP_STATE=S;
    var lines=document.querySelectorAll('[data-drop-line]'), panel=document.querySelector('[data-drop]');
    if(S.done){ lines.forEach(function(l){l.hidden=false;l.textContent='Edition 01 is complete. All 452 numbers are taken.';}); return; }
    var dn='Drop '+pad(S.n), when='26 '+MON[S.m]+', '+pad(H)+':00', left=S.at-Date.now();
    var d=Math.floor(left/864e5), h=Math.floor(left%864e5/36e5), mi=Math.floor(left%36e5/6e4), se=Math.floor(left%6e4/1e3);
    var cd=d>0?d+'d '+pad(h)+'h '+pad(mi)+'m':pad(h)+'h '+pad(mi)+'m '+pad(se)+'s';
    var txt=S.live? dn+' is open · Nos. '+S.nums[2]+' · '+S.nums[3]+' numbers' : dn+' · '+when+' · opens in '+cd;
    lines.forEach(function(l){l.hidden=false;l.textContent=txt;});
    if(panel){
      panel.hidden=false; panel.classList.toggle('is-live',S.live);
      panel.querySelector('[data-drop-title]').textContent=dn+(S.live?' · open now':'');
      panel.querySelector('[data-drop-nums]').textContent='Nos. '+S.nums[2];
      panel.querySelector('[data-drop-count]').textContent=S.live?S.nums[3]+' numbers, first come first served':cd;
      panel.querySelector('[data-drop-note]').textContent=S.live?'Request now. We confirm in the order requests arrive.':'Opens '+when+' Beirut time. Reserve now and you hear first.';
      var cta=document.querySelector('[data-drop-cta]'); if(cta) cta.textContent=S.live?'Request one of '+S.nums[3]:'Reserve for '+'26 '+MON[S.m];
      var ok=document.querySelector('[data-drop-ok]'); if(ok) ok.textContent=S.live?'We will contact you soon by email to confirm your Qada2, its finish and your number.':'You are on the list for '+dn+'. We will contact you soon, before it opens on '+when+'.';
    }
  }
  render(); setInterval(render,1000);
})();
